const donate = {
    "LBL_PAGE_TITLE":"Пожертвование",
};
export default donate